import type { TableSemanticSchema } from './types';

export const PrioritySchema: TableSemanticSchema = {
  id: 'priority',
  name: 'Priority Matrix',
  description:
    'Generic weighted-scoring priority list. Computes a weighted total and auto-ranks items — a lighter-weight counterpart to the scorecard domain for tabular data.',
  cells: [],
  itemFields: [
    { key: 'name', label: 'Name', kind: 'string', required: true },
    { key: 'score', label: 'Score', kind: 'number', required: true },
    { key: 'weight', label: 'Weight', kind: 'number', description: 'Relative importance — higher weight dominates.' },
    { key: 'category', label: 'Category', kind: 'string' },
  ],
  computedFields: [
    { key: 'weightedScore', label: 'Weighted Score',
      expression: { op: 'weighted-sum', values: 'score', weights: 'weight' } },
    { key: 'computedRank', label: 'Rank',
      expression: { op: 'rank', field: 'weightedScore', direction: 'desc' } },
  ],
  renderingHints: { layout: 'list' },
};
